import React from 'react';

/**
 * Renders a placeholder slot for when a provider/location does not have an availability.
 */
const SlotPlaceholder = () => {
  return (
    <span className={'day__time-block slot-set'} data-testid='slot-placeholder' />
  );
}

export default SlotPlaceholder;
